module.exports = __webpack_public_path__ + "img/ISE.44511be2.png";